import { Component, Input } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import { ModalInputEmailComponent } from './modal-input-email/modal-input-email.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'angular-2-local-storage';
import {Observable} from 'rxjs/Rx';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  demoOn: boolean;
  objLoaderStatus: boolean;
  timer: any;
  tick: any;
  movie: any;
  constructor(
      private router: Router,
      private modalService: NgbModal,
      private storage: LocalStorageService
  ) {
    this.storage.clearAll();
    this.objLoaderStatus = false;
  }

  over() {
    this.timer.unsubscribe();
    this.timer = Observable.timer(0, 1000).subscribe(tick => {
      this.tick = tick;
      if (this.tick >= 60) {
        this.timer.unsubscribe();
        this.storage.clearAll();
        this.router.navigateByUrl('/');
      }
    });
  }

  onDeactivate() {
    document.body.scrollTop = 0;
  }

  demoSwitch(demoOn: boolean) {
    this.demoOn = demoOn;
    this.movie = document.getElementById('movie');
    const movie = this.movie;
    movie.pause();
    movie.currentTime = 0;
  }

  openModal() {
    this.modalService.open(ModalInputEmailComponent, { windowClass: 'send-email' });
  }

  ngOnInit() {

    this.router.events.filter(e => e.constructor.name === 'RoutesRecognized')
        .pairwise()
        .subscribe((e: any[]) => {
          if (e[0].urlAfterRedirects === '/') {
            this.router.navigateByUrl('');
            this.storage.set('referer', e[1].urlAfterRedirects);
            this.openModal();
          }
    });

    this.timer = Observable.timer(0, 1000).subscribe(tick => this.tick = tick);
  }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/app.component.ts